// SVARĪGI: Dublikāts no Search.jsx pielāgots izmantošanai meklētāja ievadlaukam kā atsevišķai sekcijai

import React from 'react';
import PropTypes from 'prop-types';
import uid from 'utils/uid';
import tulkojumi from 'utils/tulkojumi';
import { Search as SearchIcon } from 'core/icons';
import { SiteContainer, FlexItem } from 'core/layout';
import { SearchResults } from './components/SearchResults';
import {
  StyledSearch,
  Form,
  Wrapper,
  Label,
  InputContainer,
  HiddenSubmit,
  IconWrapper,
} from './styled-2';

const IMMEDIATE_SEARCH_DELAY = 500;

class Search extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
      input: '',
    };
    this._uid = uid();
  }

  _clearInput = (event) => {
    this.setState(prevState => Object.assign({}, prevState, {
      input: '',
    }));
  }

  _onChange = (event) => {
    const { value } = event.target;
    this.setState(prevState => Object.assign({}, prevState, {
      input: value,
      inputFocused: true,
    }));
  }

  _onFocus = (event) => {
    const target = event.currentTarget
    const rect = target.getBoundingClientRect()
    if (rect.top > 100) {
      let pageOffsetTop = 65
      const containsCookiesInfo = document.body.querySelector(`div[data-query-id="js-cookie-info"]`)
      if (containsCookiesInfo) {
        const { height } = containsCookiesInfo.getBoundingClientRect();
        pageOffsetTop += height;
      }
      window.scrollTo({ top: this._containerRef.offsetTop - pageOffsetTop, behavior: "smooth" })
    }
  }

  _onSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }

    window.gtag && gtag('event', 'search', {
      'search_term': this.state.input,
    });

    const { input } = this.state;
    if (!input || input.length === 0) {
      return;
    }

    // NOTE: Ejam uz rezultātu lapu, input
    // pieglabājot history location state.
    const { searchLapa } = this.props;
    const { history } = this.context.router;
    history.push({
      pathname: searchLapa.path,
      search: `?q=${encodeURI(this.state.input)}`,
      state: {
        input: this.state.input,
        inputFocused: false,
      }
    });

    const { onClose } = this.props;
    this._clearInput();
    onClose && onClose();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this._input.focus();
    }

    if (this._inputTimeout) {
      window.clearTimeout(this._inputTimeout);
      this._inputTimeout = null;
    }

    if (this.state.input !== prevState.input) {
      let triggerImmediateSearch = false;
      const inputParts = this.state.input.split(/\s/g);
      if (inputParts.length > 1) {
        const completeWords = inputParts.slice(0, inputParts.length - 1);
        const isEqual = this._isEqualInputParts(completeWords, this._partialSearch);
        if (!isEqual) {
          this._partialSearch = [...completeWords];
          triggerImmediateSearch = true;
        }
      }

      if (triggerImmediateSearch) {
        this._handleSearchInput(this._partialSearch);
      } else {
        this._inputTimeout = window.setTimeout(() => {
          this._handleSearchInput(this.state.input);
        }, IMMEDIATE_SEARCH_DELAY);
      }
    }
  }

  componentWillUnmount() {
    if (this._inputTimeout) {
      window.clearTimeout(this._inputTimeout);
      this._inputTimeout = null;
    }
  }

  _isEqualInputParts = (a, b) => {
    if (!a || !b) {
      return false;
    }
    const isEqual = !a.some((word, i) => word !== b[i]);
    return isEqual;
  }

  _handleSearchInput = (query) => {
    if (Array.isArray(query)) {
      query = query.join(' ');
    }
    this.setState(prevState => Object.assign({}, prevState, {
      searchQuery: query,
    }), () => {
      const pathname = this.context.router.history.location.pathname
      if (this.triggeredSearchEvent !== pathname) {
        window.gtag && gtag('event', 'use_search', {
          'event_label': pathname,
        });
        this.triggeredSearchEvent = pathname
      }
    });
  }

  render() {
    const {
      isOpen = true,
      onClose = () => {},
      teksti,
    } = this.props;

    return (
      <StyledSearch open={isOpen} innerRef={c => { this._containerRef = c }} data-id='search-block'>
        <SiteContainer>
          <InputContainer align='center' justify='center'>
            <FlexItem basis={8/12}>
              <Form
                role='search'
                onSubmit={this._onSubmit}
              >
                <Wrapper>
                  <input
                    autoComplete='off'
                    ref={c => this._input = c}
                    tabIndex={isOpen ? '0' : '-1'}
                    name='q'
                    aria-label={tulkojumi(teksti, 'meklet_lapas_satura')}
                    id={`search-${this._uid}`}
                    onChange={this._onChange}
                    onFocus={this._onFocus}
                    value={this.state.input}
                  />
                  <IconWrapper>
                    <SearchIcon />
                  </IconWrapper>
                  <Label
                    htmlFor={`search-${this._uid}`}
                  >
                    {!this.state.input || this.state.input.length < 1 ? <span>
                      {tulkojumi(teksti, 'es_mekleju')}
                    </span> : null}
                  </Label>
                  <HiddenSubmit type="submit" aria-label={tulkojumi(teksti, 'meklet_lapas_satura')} aria-hidden="true" tabIndex="-1">
                    {tulkojumi(teksti, 'meklet_lapas_satura')}
                  </HiddenSubmit>
                </Wrapper>
              </Form>

              {/* TODO: Pieejamības iestrādne navigācijai
              ar klaviatūru – pogas uz augšu/leju */}
              <SearchResults
                lang={this.props.lang}
                query={this.state.searchQuery}
                onSubmit={this._onSubmit}
                onClose={() => {
                  this.setState(prevState => ({
                    ...prevState,
                    inputFocused: false,
                  }))
                }}
                show={this.state.inputFocused}
                history={this.context.router.history}
              />

            </FlexItem>
          </InputContainer>

        </SiteContainer>
      </StyledSearch>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/modules/Header/components/Search/SearchBlock.jsx